import { Swiper, Keyboard, Pagination, A11y } from 'swiper';

const imageCarouselTeaserSections = document.querySelectorAll(".adm-section-c28-image-carousel-teaser");

Array.prototype.forEach.call(imageCarouselTeaserSections, (imageCarouselTeaserSection, index) => {
    imageCarouselTeaserSection.classList.add(`section-${index}`);

    if (window.innerWidth < 1259 && window.innerWidth > 767) {
        imageCarouselTeaserSection.querySelector(".swiper").setAttribute("dir", "rtl");
    }

    setTimeout(() => {
        var swiperc28 = new Swiper(`.adm-section-c28-image-carousel-teaser.section-${index} .swiper`,
            {
                modules: [A11y, Keyboard, Pagination],
                slidesPerView: imageCarouselTeaserSection.classList.contains("cards-3") ? 4 : 5,
                spaceBetween: 0,
                slidesPerGroup: 1,
                loop: true,
                loopFillGroupWithBlank: true,
                a11y: {
                    prevSlideMessage: "Previous slide",
                    nextSlideMessage: "Next slide"
                },
                keyboard: {
                    enabled: true,
                    onlyInViewPort: false,
                },
                pagination: {
                    el: `.adm-section-c28-image-carousel-teaser.section-${index} .adm-c28-swiper-pagination`,
                    clickable: true,
                    renderBullet: function (bulletIndex, className) {
                        return (
                            `<span class="${className}">0${bulletIndex + 1}</span>`
                        );
                    }
                }
            });


        const scrollBarPosition = imageCarouselTeaserSection.querySelector(
            ".adm-svg-c28-image-carousel-teaser-scroll-bar-2"
        );
        const paginationNumbers = imageCarouselTeaserSection.querySelector(".adm-c28-swiper-pagination").children;

        swiperc28.on("slideChangeTransitionEnd",
            function () {
                for (let i = 0; i < paginationNumbers.length; i++) {
                    scrollBarPosition?.
                        classList.remove(`card-${i + 1}`);
                }
                scrollBarPosition?.
                    classList.add(`card-${swiperc28.realIndex + 1}`);
            });

        //keyboard tabbing
        function addTabIndexToSlides(slideIndex, total) {
            for (let i = slideIndex; i < total; i++) {
                swiperc28.slides[i].tabIndex = 0;
            }
        }

        if (swiperc28.slides.length === 16) {
            addTabIndexToSlides(5, 11);
        } else {
            const slidesCount = swiperc28.slides.length / 3;
            const total = slidesCount * 2;
            addTabIndexToSlides(slidesCount, total);
        }

        swiperc28.on("keyPress",
            (s) => {
                swiperc28.pagination.bullets.forEach(bullet => bullet.tabIndex = -1);
                s.slides.forEach((slide, slideIndex) => {
                    slide.addEventListener("focusin",
                        () => {
                            slide.querySelector(".adm-div-c10-card-custom-position-")?.
                                classList.add("adm-card-bottom-visible");
                            s.slideTo(slideIndex, 300);
                        });
                });
            });
    },
        100);
});


//Mobile swiper
const imageCarouselTeaserMobileSections = document.querySelectorAll(".adm-section-c28-image-carousel-teaser-mobile");

Array.prototype.forEach.call(imageCarouselTeaserMobileSections, (imageCarouselTeaserMobileSection, index) => {
    imageCarouselTeaserMobileSection.classList.add(`section-${index}`);

    var swiperc28Mobile = new Swiper(`.adm-section-c28-image-carousel-teaser-mobile.section-${index} .swiper`,
        {
            modules: [A11y, Pagination],
            slidesPerView: 6,
            spaceBetween: 0,
            slidesPerGroup: 1,
            centeredSlides: true,
            a11y: {
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide"
            },
            pagination: {
                el: `.adm-section-c28-image-carousel-teaser-mobile.section-${index} .adm-c28-swiper-pagination-mobile`,
                clickable: true,
                renderBullet: function (bulletIndex, className) {
                    return (
                        `<span class="${className}">0${bulletIndex + 1}</span>`
                    );
                }
            }
        });

    const paginationNumbersMobile = imageCarouselTeaserMobileSection.querySelector(".adm-c28-swiper-pagination-mobile").children;
    const scrollBarPositionMobile = imageCarouselTeaserMobileSection.querySelector(".adm-svg-c28-image-carousel-teaser-scroll-bar-2");

    swiperc28Mobile.on("slideChangeTransitionEnd",
        function () {
            for (let i = 0; i < paginationNumbersMobile.length; i++) {
                scrollBarPositionMobile?.
                    classList.remove(`card-${i + 1}`);
            }
            scrollBarPositionMobile?.
                classList.add(`card-${swiperc28Mobile.realIndex + 1}`);
        });
});